// extracted by mini-css-extract-plugin
export default {"experience":"Experience_experience__PO1R8","expericence":"Experience_expericence__cIrUs"};